import React from 'react';
import {FooterContainer} from "./Footer.styles";

function Footer() {
    return (
        <FooterContainer>© 2023 Copyright: FoodSpot</FooterContainer>
    )
}

export default Footer;
